import { styled } from '@nykaa/ui-components';
import Image from 'shared/components/Image';

export const Wrapper = styled.div`
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing.spacing20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
  margin-top: ${({ theme }) => theme.spacing.spacing40};

  &::-webkit-scrollbar {
    display: none !important;
  }
`;

export const ImageItem = styled.div`
  display: inline-block;
  margin: ${({ theme }) => `0 ${theme.spacing.spacing40} 0 0`};
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  width: 90px;
  height: 120px;
  overflow: hidden;
  position: relative;
`;

export const Img = styled(Image)`
  img {
    object-fit: cover;
  }
`;

export const RemainingItems = styled.span`
  position: absolute;
  flex-direction: column;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  width: 100%;
  height: 100%;
  z-index: 1;
  color: #fff;
  background: rgba(0, 0, 0, 0.75);
`;
